export default __webpack_public_path__ + "static/media/566.74febfe8.png";